export const QUERY_PARAMS = [
  {
    name: "start",
    type: "number",
    description: `A cursor used in pagination.  This is the row number of the full set of results. 
       The API limits results to a max of 200 results per call.  If you want to retrieve the next set
        of results you can use this parameter to retrive the next set of results.  For example if you
         are retrieving 200 results at a time, you can set start=201 to retrieve the next page of results.`
  },
  {
    name: "maxresults",
    type: "number",
    description: `The maximum number of results you want to return.  The default is 200, the maximum value allowed.`
  }
];

export const RESULTS = `{
  "count": 61,
  "totalCount": 61,
  "data": [],
  "status": "ok",
  "message": ""
}`;

export const ACCOUNT_JSON = `{
  "id": 31,
  "syncToken": 0,
  "name": "Accounts Payable",
  "fullname": "Accounts Payable",
  "parentId": null,
  "sublevel": 0,
  "accountType": "AccountsPayable"
}`;

export const ACCOUNT = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The name on the account.`
  },
  {
    name: "fullname",
    type: "string",
    description: `The full name on the account.`
  },
  {
    name: "parentID",
    type: "integer",
    description: "The id of the parent account, if one exists."
  },
  {
    name: "sublevel",
    type: "integer",
    description:
      "The number of levels down the account tree that this one belongs."
  },
  {
    name: "accountType",
    type: "string",
    description: "The type of this account."
  }
];

export const BIN_JSON = `{ 
    "id":3,
    "syncToken":0,
    "number":"B-9",
    "location":{ 
      "id":2,
      "name":"Warehouse"
    },
    "sortOrder":0,
  }`;

export const BIN = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "number",
    type: "string",
    description: `The bin number.`
  },
  {
    name: "location",
    type: "reference",
    description: `Refers to this bin's location.`
  },
  {
    name: "sortOrder",
    type: "integer",
    description: `The order position (e.g., 1, 2, or 3) which this bin holds in the sequential numbering of bins. The minimum value is 0, the maximum 9999. The default is 0. Typically, sort order pertains to the order of bins in a warehouse.`
  }
];

export const CHANNEL_JSON = `{ 
  "id":6,
  "syncToken":0,
  "name":"Catalog"
}`;

export const CHANNEL = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The channel name.`
  }
];

export const CLASS_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"Class"
  }`;

export const CLASS = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The class name.`
  }
];

export const CUSTOM_FIELD_JSON = `{ 
  "id":31,
  "syncToken":0,
  "name":"Custom Field",
  "dataType":"Text",
  "showOn":"Builds, Work Orders",
  "listValues":null
}`;

export const CUSTOM_FIELD = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The name of the custom field.`
  },
  {
    name: "dataType",
    type: "string",
    description: `The type of the custom field.  One of Text, Boolean, List, Number, TextArea, Date, or Money.`
  },
  {
    name: "showOn",
    type: "string",
    description: `Comma-separated list of the transactions on which this field is shown.`
  },
  {
    name: "listValues",
    type: "string",
    description: `Comma-separated list of value, if data type is set to List.`
  }
];

export const DEPARTMENT_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"Class"
}`;

export const DEPARTMENT = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The department name.`
  }
];
export const LOCATION_JSON = `{ 
  "id":8,
  "syncToken":0,
  "name":"Warehouse",
  "binTracking":false,
  "bins":[ ],
  "address":{ 
    "line1":"123 Brew Lane",
    "line2":"",
    "line3":null,
    "line4":null,
    "line5":null,
    "city":"Arlington",
    "stateProvince":"TX",
    "postalCode":"77090",
    "country":""
  },
  "phone":"888-555-1212",
  "email":"dtest@sosinventory.com",
  "contact":"",
  "keys":null,
  "values":null
  }`;

export const LOCATION = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The location name.`
  },
  {
    name: "binTracking",
    type: "boolean",
    description: `True if location is bin tracked, false if not.`
  },
  {
    name: "bins",
    type: "array of bin references",
    description: `The bins setup for this location, if bin tracking is enabled.`
  },
  {
    name: "address",
    type: "address object",
    description: `The address for this location.  See example for address fields.`
  },
  {
    name: "phone",
    type: "string",
    description: `The phone number for this location.`
  },
  {
    name: "email",
    type: "string",
    description: `The email for this location.`
  },
  {
    name: "company",
    type: "string",
    description: `The company for this location.`
  },
  {
    name: "contact",
    type: "string",
    description: `The contact for this location.`
  },
  {
    name: "keys",
    type: "",
    description: `Reserved for future use.`
  },
  {
    name: "values",
    type: "",
    description: `Reserved for future use.`
  }
];
export const ORDER_STAGE_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"Received"
  }`;

export const ORDER_STAGE = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The order stage name.`
  }
];
export const PAYMENT_METHOD_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"Cash"
  }`;

export const PAYMENT_METHOD = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The payment method name.`
  }
];
export const PRICE_TIER_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"20% discount",
    "percentDiscount": 20.00000
  }`;

export const PRICE_TIER = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The price tier name.`
  },
  {
    name: "percentDiscount",
    type: "decimal",
    description: `If using percentage discounts, the percentage applied for this price tier.`
  }
];
export const PRIORITY_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"High"
  }`;

export const PRIORITY = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The priority name.`
  }
];
export const SALESREP_JSON = `{ 
    "id":17,
    "syncToken":0,
    "lastName":"Kerry",
    "firstName:"Jason"
  }`;

export const SALESREP = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "lastName",
    type: "string",
    description: `The sales rep's last name.`
  },
  {
    name: "firstName",
    type: "string",
    description: `The sales rep's first name.`
  }
];
export const SHIP_METHOD_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"USPS"
  }`;

export const SHIP_METHOD = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The ship method name.`
  }
];
export const TAX_CODE_JSON = `{
  "id": 10,
  "syncToken": 0,
  "name": "20%",
  "salesTaxRate": 20.0000000000,
  "purchaseTaxRate": 0.0,
  "isSalesTaxType": true,
  "isPurchaseTaxType": false
}`;

export const TAX_CODE = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The tax code name.`
  },
  {
    name: "salesTaxRate",
    type: "decimal",
    description: `The tax rate used on sales transactions.`
  },
  {
    name: "purchaseTaxRate",
    type: "decimal",
    description: `The tax rate used on purchase transactions.`
  },
  {
    name: "isSalesTaxType",
    type: "boolean",
    description: `True if tax code is applicable to sales transactions, false if not.`
  },
  {
    name: "isPurchaseTaxType",
    type: "boolean",
    description: `True if tax code is applicable to purchasing transactions, false if not.`
  }
];
export const TERMS_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"30 days"
  }`;

export const TERMS = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The term name`
  }
];
export const UOM_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"Dozen",
    "abbreviation": "doz"
  }`;

export const UOM = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The unit of measure name.`
  },
  {
    name: "abbreviation",
    type: "string",
    description: `The abbreviation used for this unit of measure.`
  }
];
export const USER_JSON = `{ 
  "id":1,
  "syncToken":0,
  "name":"Joe User",
  "email": "joeuser@gmail.com"
}`;

export const USER = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The user's name`
  },
  {
    name: "email",
    type: "string",
    description: `The user's email address`
  }
];
export const WARRANTY_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"1 Year"
  }`;

export const WARRANTY = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The warranty name.`
  }
];
export const WORK_CENTER_JSON = `{ 
    "id":1,
    "syncToken":0,
    "name":"Cut"
  }`;

export const WORK_CENTER = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "name",
    type: "string",
    description: `The work center name.`
  }
];
export const WORKER_JSON = `{ 
    "id":1,
    "syncToken":0,
    "lastName":"Smith",
    "firstName:"John"
  }`;

export const WORKER = [
  {
    name: "id",
    type: "integer",
    description: "Unique identifier for this record."
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record.`
  },
  {
    name: "lastName",
    type: "string",
    description: `The worker's last name.`
  },
  {
    name: "firstName",
    type: "string",
    description: `The worker's first name.`
  }
];
